// 组件对象，大写
import panguSelect from './panguSelect.vue'
export default panguSelect
